// ── Diálogos no estilo do app (no lugar de confirm/alert do navegador) ───────
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { loadLS } from "./storage";
import { parseThemeStyle, loadThemePref, makeTheme } from "./theme";
import { NavIcon } from "../components/icons";

export const _dlg = { push: null, theme: null };
export function appDialog(opts) {
  return new Promise(res => {
    if (_dlg.push) _dlg.push({ ...opts, res });
    else if (opts.kind === "confirm") res(window.confirm(opts.message)); // reserva, se o app ainda não montou
    else { window.alert(opts.message); res(true); }
  });
}
export const appConfirm = (message, o = {}) => appDialog({ kind: "confirm", message, ...o });
export const appAlert   = (message, o = {}) => appDialog({ kind: "alert", message, ...o });
// O app injeta aqui o tema atual, para os diálogos usarem o mesmo visual.
export function setDialogTheme(t) { _dlg.theme = t; }

export function DialogHost() {
  const [queue, setQueue] = useState([]);
  useEffect(() => { _dlg.push = d => setQueue(q => [...q, d]); return () => { _dlg.push = null; }; }, []);
  const d = queue[0];
  const close = val => { d.res(val); setQueue(q => q.slice(1)); };
  useEffect(() => {
    if (!d) return;
    const onKey = e => { if (e.key === "Escape") close(d.kind === "confirm" ? null : true); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  });
  if (!d) return null;
  const t = _dlg.theme || (() => { const ps = parseThemeStyle(loadThemePref()); return makeTheme(ps.style, loadLS("sf_themeMode", "dark"), loadLS("sf_accentId", "blue"), ps.instBase, ps.instMetal); })();
  const danger = !!d.danger;
  const mainBg = danger ? "#E5484D" : t.ac;
  const mainFg = danger ? "#fff" : (t.onAc || "#fff");
  const icon = d.icon || (danger ? "alerta" : d.kind === "confirm" ? "questoes" : "checkcirc");
  const iconColor = danger ? "#F87171" : t.ac;
  const btn = { minHeight: 42, borderRadius: 10, padding: "0 1.1rem", fontSize: "0.88rem", fontWeight: 700, cursor: "pointer", fontFamily: "inherit" };
  return ReactDOM.createPortal(
    <div onClick={() => close(d.kind === "confirm" ? null : true)}
      style={{ position: "fixed", inset: 0, zIndex: 100000, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem" }}>
      <style>{`@keyframes g17dlg{from{opacity:0;transform:translateY(8px) scale(.98)}to{opacity:1;transform:none}}`}</style>
      <div role="alertdialog" aria-modal="true" aria-labelledby="g17-dlg-t" aria-describedby="g17-dlg-m" onClick={e => e.stopPropagation()}
        style={{ width: "100%", maxWidth: 400, background: t.bgCard, color: t.text, border: `1px solid ${t.border}`, borderRadius: 16, padding: "1.4rem 1.4rem 1.2rem",
          boxShadow: t.mode === "dark" ? "0 24px 64px rgba(0,0,0,0.55)" : "0 24px 64px rgba(20,24,40,0.18)", fontFamily: t.fontBody, animation: "g17dlg .16s ease-out" }}>
        <div style={{ display: "flex", gap: "0.9rem", alignItems: "flex-start" }}>
          <div style={{ width: 40, height: 40, borderRadius: 12, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center",
            background: danger ? "rgba(229,72,77,0.12)" : t.acDim, border: `1px solid ${danger ? "rgba(229,72,77,0.35)" : t.acBorder}`, color: iconColor }}>
            <NavIcon id={icon} size={20} />
          </div>
          <div style={{ minWidth: 0, flex: 1 }}>
            <h2 id="g17-dlg-t" style={{ margin: "0.1rem 0 0.35rem", fontSize: "1.02rem", fontWeight: 800, color: t.text, fontFamily: t.fontBody, lineHeight: 1.3 }}>
              {d.title || (d.kind === "confirm" ? "Confirmar" : "Pronto")}
            </h2>
            <p id="g17-dlg-m" style={{ margin: 0, fontSize: "0.88rem", lineHeight: 1.55, color: t.textMid, whiteSpace: "pre-line", overflowWrap: "anywhere" }}>{d.message}</p>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.55rem", marginTop: "1.3rem", flexWrap: "wrap" }}>
          {d.kind === "confirm" && (
            <button onClick={() => close(false)} style={{ ...btn, background: "transparent", border: `1px solid ${t.border}`, color: t.textMid }}>{d.cancelText || "Cancelar"}</button>
          )}
          <button autoFocus onClick={() => close(true)} style={{ ...btn, background: mainBg, border: "none", color: mainFg, minWidth: 96 }}>
            {d.confirmText || (d.kind === "confirm" ? "Confirmar" : "Ok")}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
